import { makeAutoObservable, runInAction } from 'mobx'
import { ContactsInterface } from './contacts.interfaces'
import { openApi } from "../../helpers/request";
import i from '../../translations/i'
import { FormEvent } from 'react'
import { message, notification } from 'antd'

class contactsController {

    list: ContactsInterface[] = []
    element: ContactsInterface = {
        id: 0,
        title: '',
        type: '',
        value: '',
        warehouse_id: null,
        to_order: true
    }

    pagination = {
        total: 0,
        limit: 10,
        page: 1,
        offset: 0
    }

    selectedWarehouse: any = null

    types = [
        { name: 'phone',        description: i.t('contacts:types.phone') },
        { name: 'email',        description: i.t('contacts:types.email') },
        { name: 'address',      description: i.t('contacts:types.address') },
        { name: 'schedule',     description: i.t('contacts:types.schedule') },
        { name: 'vk',           description: i.t('contacts:types.vk') },
        { name: 'instagram',    description: i.t('contacts:types.instagram') },
        { name: 'facebook',     description: i.t('contacts:types.facebook') },
        { name: 'twitter',      description: i.t('contacts:types.twitter') },
        { name: 'telegram',     description: i.t('contacts:types.telegram') },
        { name: 'website',      description: i.t('contacts:types.website') },
        { name: 'whatsapp',     description: i.t('contacts:types.whatsapp') },
        { name: 'viber',        description: i.t('contacts:types.viber') },
        { name: 'max',          description: 'Max' },
        { name: 'text',        description: i.t('contacts:types.text') },
        { name: 'companyName',         description: i.t('contacts:types.companyName') },
    ]

    constructor() {
        makeAutoObservable(this)
    }

    getTypeByName(name: string): string {
        const index = this.types.findIndex(el => el.name === name)
        return index > -1 ? this.types[index].description : ''
    }

    get(elementID: null | number = null, wh_id: number | null = null) {
        if(elementID) {
            openApi('get', `/contacts/${elementID}`)
              .then(result => {
                  console.log(result)
                  runInAction(() => {
                      this.element = result.data
                  })
              })
        } else {
            let path = `/contacts`
            if(wh_id) path = `/contacts?warehouse_id=${wh_id}`

            console.log(path)

            openApi('get', path)
              .then(result => {
                  console.log(result)
                  this.list = result.data
              })
              .catch(error => {
                  console.log(error)
              })
        }
    }

    set(name: string, value: any) {
        //@ts-ignore
        this.element[name] = value
    }

    setPage(page: number) {
        this.pagination.page = page
        if (page > 0) {
            this.pagination.offset =
                this.pagination.limit * page - this.pagination.limit
        } else {
            this.pagination.offset = 0
        }
        this.get()
    }

    setWarehouse(e: any) {
        this.selectedWarehouse = e
        this.get(null, e)
    }

    remove(elementID: string | number) {
        if (window.confirm(i.t('def:confirms.delete'))) {
            openApi('delete', `/contacts/${elementID}`)
              .then(result => {
                  this.get(null, this.selectedWarehouse)
              })
              .catch(error => {
                  message.error(i.t('def:errors.remove'))
              })
        }
    }

    save(e: FormEvent) {
        e.preventDefault()

        let data = new FormData()
        data.append('id', `${this.element.id}`)
        data.append('title', this.element.title ?? '')
        data.append('type', this.element.type)
        data.append('value', this.element.value)
        if(this.element.warehouse_id) data.append('warehouse_id', `${this.element.warehouse_id}`)
        data.append('to_order', `${+ this.element.to_order}`)

        let path = `/contacts`
        if(this.element.id && this.element.id > 0) path = `/contacts/${this.element.id}`

        openApi('post', path, data)
          .then(result => {
              window.location.href = `/contacts`
          })
          .catch(error => {
              console.log(error.response)
              notification.error({
                  message: i.t('def:errors.error'),
                  description: error.response?.data?.data?.message ?? ''
              })
          })
    }

}

export default new contactsController()